import React from "react";
import { useSearchParams } from "react-router-dom";
import { Layers, Store, ShoppingBag, PackageCheck, TrendingUp, Award, Radar } from "lucide-react";
import { PageHeader } from "../lib/ui";
import BranchDemandTab from "../components/supplychain/BranchDemandTab";
import SuppliersTab from "../components/supplychain/SuppliersTab";
import PurchaseOrdersTab from "../components/supplychain/PurchaseOrdersTab";
import ReceivingTab from "../components/supplychain/ReceivingTab";
import PriceHistoryTab from "../components/supplychain/PriceHistoryTab";
import SupplierPerfTab from "../components/supplychain/SupplierPerfTab";
import TraceabilityView from "../components/supplychain/TraceabilityView";

const TABS = [
  { id: "demand", label: "Permintaan Cabang", icon: Layers },
  { id: "suppliers", label: "Pemasok", icon: Store },
  { id: "orders", label: "Pesanan Pembelian", icon: ShoppingBag },
  { id: "receiving", label: "Penerimaan Barang", icon: PackageCheck },
  { id: "prices", label: "Riwayat Harga", icon: TrendingUp },
  { id: "performance", label: "Performa Supplier", icon: Award },
  { id: "trace", label: "Telusur Rantai Pasok", icon: Radar },
];

export default function PurchasingWorkspace() {
  const [params, setParams] = useSearchParams();
  const tab = TABS.some((t) => t.id === params.get("tab")) ? params.get("tab") : "demand";
  const setTab = (id) => setParams(id === "demand" ? {} : { tab: id });

  return (
    <div className="animate-fade-up pb-24 lg:pb-2" data-testid="purchasing-workspace">
      <PageHeader icon={Layers} title="Pusat Kendali Rantai Pasok" subtitle="Pusat operasional pengadaan: permintaan, supplier, PO, penerimaan, harga, performa & telusur" />

      <div className="mt-4 -mx-1 flex gap-1.5 overflow-x-auto px-1 pb-1">
        {TABS.map((tb) => (
          <button key={tb.id} onClick={() => setTab(tb.id)} data-testid={`sc-tab-${tb.id}`}
            className={`flex shrink-0 items-center gap-2 rounded-xl px-3.5 py-2 text-sm font-semibold transition-colors ${tab === tb.id ? "bg-primary text-white shadow-sm" : "bg-white text-ink-soft ring-1 ring-line hover:bg-stone-50"}`}>
            <tb.icon size={16} /> {tb.label}
          </button>
        ))}
      </div>

      <div className="mt-5">
        {tab === "demand" && <BranchDemandTab />}
        {tab === "suppliers" && <SuppliersTab />}
        {tab === "orders" && <PurchaseOrdersTab />}
        {tab === "receiving" && <ReceivingTab />}
        {tab === "prices" && <PriceHistoryTab />}
        {tab === "performance" && <SupplierPerfTab />}
        {tab === "trace" && <TraceabilityView />}
      </div>
    </div>
  );
}
